<template>
    <v-data-table
        calculate-widths
        :multi-sort="setup.pagination.multiSort"
        :loading="setup.loading"
        :headers="setup.headers"
        :items="setup.items"
        :server-items-length="setup.totalItems"
        :options.sync="setup.pagination"
        :footer-props="setup.footerProps"
        :loading-text="$t('common.dataTable.loadingText')"
        :no-data-text="$t('common.dataTable.noDataText')"
        @click:row="rowCtrlClicked"
    >
        <template v-for="(column, index) in setup.headers" #[`item.${column.value}`]="{ item }">
            <template functional v-if="column.img">
                <v-avatar :tile="column.img.tile" :size="column.img.width" :color="avatarColor(item)" :key="index">
                    <v-img
                        v-if="$helpers.getObjectValueByPath(item, column.value)"
                        :src="$helpers.getObjectValueByPath(item, column.value).url"
                        :max-height="column.img.height"
                        :min-width="column.img.width"
                        :max-width="column.img.width"
                        class="ma-auto"
                    ></v-img>
                    <span class="white--text avatar--letter" v-else>
                        <template v-if="column.img.else.value">{{ item[column.img.else.key][column.img.else.value] | initialName }}</template>
                        <template v-else>{{ item[column.img.else.key] | initialName }}</template>
                    </span>
                </v-avatar>
            </template>

            <template functional v-else-if="column.date">
                <span :key="index" class="has-late" :ref="`${column.value}${item['objectId']}`" :class="lateDeadline((column.value+item['objectId']), column.value, item[column.value])">{{ (item[column.value] === undefined || item[column.value].iso === '9000-01-01T00:00:00.000Z') ? undefined : item[column.value] | momentFormatDate("L") }}</span>
            </template>

            <template functional v-else-if="column.background">
                <span :key="index" class="has-background" :data-color="$helpers.getObjectValueByPath(item, column.background)">{{ $helpers.getObjectValueByPath(item, column.value) }}</span>
            </template>

            <template functional v-else-if="column.filePreview && item[column.value]">
                <file-preview :key="index" :ref="`${column.value}${item['objectId']}`" :file="item[column.value]" />
            </template>

            <template functional v-else>
                <span :key="index" v-html="$helpers.getObjectValueByPath(item, column.value)"></span>
            </template>
        </template>

        <template v-slot:item.actions="{ item }">
            <v-btn v-if="actionEditIsEnabled" class="ma-1" depressed outlined icon fab dark color="primary" small :to="actionEditParams(item)" data-action="edit">
                <v-icon data-action="edit">edit</v-icon>
            </v-btn>
            <v-btn v-if="actionDeleteIsEnabled" class="ma-1" depressed outlined icon fab dark color="pink" small @click="deleteItem(item)" data-action="delete">
                <v-icon data-action="delete">delete</v-icon>
            </v-btn>
            <v-btn v-if="actionIsActiveIsEnabled" class="ma-1" depressed outlined icon fab dark color="pink" small @click="isActiveItem(item)" data-action="isActive">
                <v-icon data-action="isActive">{{ setup.isActiveIcon }}</v-icon>
            </v-btn>
        </template>
    </v-data-table>
</template>

<script>
import FilePreview from '@/components/FilePreview'

export default {
    name: 'datatable',
    props: ['setup'],
    components: {
        FilePreview
    },
    data () {
        return {
            enabled: null,
            componentKey: 0
        }
    },
    computed: {
        actionEditIsEnabled () {
            let header = this.setup.headers.find(x => x.value === 'actions')
            return header.edit
        },
        actionDeleteIsEnabled () {
            let header = this.setup.headers.find(x => x.value === 'actions')
            return header.delete
        },
        actionIsActiveIsEnabled () {
            let header = this.setup.headers.find(x => x.value === 'actions')
            return header.isActive
        }
    },
    watch: {
        'setup.pagination': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.formatSort()
                    this.$emit('update:setup', this.setup)
                }
            },
            deep: true
        },
        'setup.loading': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    if (!val) {
                        this.paintCell()
                    } else {
                        this.setup.items = []
                    }
                }
            },
            deep: true
        }
    },
    methods: {
        actionEditParams (item) {
            let editParams = { name: this.setup.editTo, params: { id: item.objectId } }
            if (this.setup.editParams) {
                editParams.params.requesterType = this.setup.editParams
            }
            return editParams
        },
        formatSort () {
            this.setup.pagination.sortFormated = this.setup.pagination.sortBy.map((sort, index) => {
                let valueSort = sort.split('.')
                return { value: valueSort[0], descending: this.setup.pagination.sortDesc[index] }
            })
        },
        avatarColor (item) {
            return (item.color) ? item.color : 'white'
        },
        deleteItem (item) {
            if (confirm(`${this.$t('common.dataTable.deleteConfirm')} ${this.setup.itemName}?`)) {
                this.$emit('delete-item', item)
            }
        },
        isActiveItem (item) {
            if (confirm(`${this.setup.isActiveMessage} ${this.setup.itemName}?`)) {
                this.$emit('is_active-item', item)
            }
        },
        rowCtrlClicked (item) {
            if (event.target.dataset.action === undefined && this.setup.detailTo) {
                let params = {
                    id: (this.setup.requesterItemId) ? this.setup.requesterItemId.split('.').reduce((o, i) => o[i], item) : item.objectId,
                    requesterType: this.setup.requesterType,
                    requesterId: this.$route.params.id
                }
                this.$router.push({ name: this.setup.detailTo, params: params }).catch(e => {})
            }
        },
        async paintCell () {
            await this.$helpers.sleep(0)
            let cells = document.getElementsByClassName('has-background')
            if (cells.length > 0) {
                for (let index = 0; index < cells.length; index++) {
                    let father = cells[index].parentElement
                    father.setAttribute('style', 'background-color: ' + cells[index].getAttribute('data-color'))
                }
            }
        },
        async lateDeadline (element, column, value) {
            await this.$helpers.sleep(0)
            let isLateClass = ''
            if (column === 'deadlineDate') {
                if (value !== undefined && this.$refs[element][0] !== undefined) {
                    if (new Date(value.iso) < new Date()) {
                        let father = this.$refs[element][0].parentElement
                        let grandFather = father.parentElement
                        grandFather.setAttribute('class', 'row-clickable')
                        father.setAttribute('style', 'color: rgba(255, 0, 0, 1); background-color: rgba(255, 0, 0, 0.2);')
                        isLateClass = 'isLate'
                    }
                }
            }
            return isLateClass
        }
    }
}
</script>

<style lang="sass">
    .late-deadline
        color: white
        background-color: red

    .tr-clickable
        tbody
            tr
                cursor: pointer

    .row-clickable
        cursor: pointer
</style>
